export default __webpack_public_path__ + "static/media/comingsoon.11cc6801.jpg";